import tripoolSwapABI from './json/3pool/swap';
import raiSwapABI from './json/xdai/rai/swap';
import raiDepositABI from './json/xdai/rai/deposit';
import eureSwapABI from './json/xdai/eure/swap';
import eureDepositABI from './json/xdai/eure/deposit';
import lusdDepositABI from './json/lusd/deposit';


import Plain2Basic from './json/factory-v2/Plain2Basic';
import Plain2BasicEMA from './json/factory-v2/Plain2BasicEMA';
import Plain2Balances from './json/factory-v2/Plain2Balances';
import Plain2ETH from './json/factory-v2/Plain2ETH';
import Plain2ETHEMA from './json/factory-v2/Plain2ETHEMA';
import Plain2Optimized from './json/factory-v2/Plain2Optimized';
import Plain3Basic from './json/factory-v2/Plain3Basic';
import Plain3Balances from './json/factory-v2/Plain3Balances';
import Plain3ETH from './json/factory-v2/Plain3ETH';
import Plain3Optimized from './json/factory-v2/Plain3Optimized';
import Plain4Basic from './json/factory-v2/Plain4Basic';
import Plain4Balances from './json/factory-v2/Plain4Balances';
import Plain4ETH from './json/factory-v2/Plain4ETH';
import Plain4Optimized from './json/factory-v2/Plain4Optimized';
import DepositZapFantom from './json/factory-v2/DepositZapFantom';
import MetaUSD from './json/factory-v2/MetaUSD';
import MetaUSDBalances from './json/factory-v2/MetaUSDBalances';
import MetaBTC from './json/factory-v2/MetaBTC';
import MetaBTCBalances from './json/factory-v2/MetaBTCBalances';

const multicall_address = '0xb5b692a88bdfc81ca69dcb1d924f59f0413a602a';

const poolsData = {
    '3pool': {
        swap_abi: tripoolSwapABI,
        N_COINS: 3,
        coin_precisions: [1e18, 1e6, 1e6],
        wrapped_precisions: [1e18, 1e6, 1e6],
        tethered: [false, false, false],
        use_lending: [false, false, false],
        is_plain: [true, true, true],
        swap_address: '0x7f90122BF0700F9E7e1F688fe926940E8839F353',
        token_address: '0x1337BedC9D22ecbe766dF105c9623922A27963EC',
        gauge_address: '0x78CF256256C8089d68Cde634Cf7cDEFb39286470',
        underlying_coins: [
            '0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d',
            '0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83',
            '0x4ECaBa5870353805a9F068101A40E0f32ed605C6',
        ],
        coins: [
            '0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d',
            '0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83',
            '0x4ECaBa5870353805a9F068101A40E0f32ed605C6',
        ],
    },
    rai: {
        swap_abi: raiSwapABI,
        N_COINS: 2,
        coin_precisions: [1e18, 1e18],
        wrapped_precisions: [1e18, 1e18],
        tethered: [false, false],
        use_lending: [false, false],
        is_plain: [true, true],
        swap_address: '0x85bA9Dfb4a3E4541420Fc75Be02E2B42042D7e46',
        token_address: '0x36390a1Ae126f16C5D222CB1F2AB341dD09f2FEC',
        gauge_address: '0x78CF256256C8089d68Cde634Cf7cDEFb39286470', // NO GAUGE FOR THIS POOL BUT NECESSARY TO AVOID REVERTS
        underlying_coins: [
            '0xd7a28aa9c470e7e9d8c676bcd5dd2f40c5683afa',
            '0x1337BedC9D22ecbe766dF105c9623922A27963EC',
        ],
        coins: [
            '0xd7a28aa9c470e7e9d8c676bcd5dd2f40c5683afa',
            '0x1337BedC9D22ecbe766dF105c9623922A27963EC',
        ],
        deposit_abi: raiDepositABI,
        deposit_address: '0xdf6eb52c4A9d7d5964b918c50D47a643Fd7D3D4c',
        is_meta: true,
        base_pool: '3pool',
        meta_N: 5,
        meta_precisions: [1e18, 1e18, 1e18, 1e6, 1e6],
        meta_coin_precisions: [1e18, 1e18, 1e6, 1e6],
        meta_wrapped_precisions: [1e18, 1e18],
        meta_coins: [
            '0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d',
            '0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83',
            '0x4ECaBa5870353805a9F068101A40E0f32ed605C6',
        ],
        all_coins: [
            '0xd7a28aa9c470e7e9d8c676bcd5dd2f40c5683afa',
            '0x1337BedC9D22ecbe766dF105c9623922A27963EC',
            '0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d',
            '0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83',
            '0x4ECaBa5870353805a9F068101A40E0f32ed605C6',
        ],
        is_factory: false,
    },
    eureusd: {
        swap_abi: eureSwapABI,
        N_COINS: 2,
        coin_precisions: [1e18, 1e18],
        wrapped_precisions: [1e18, 1e18],
        tethered: [false, false],
        use_lending: [false, false],
        is_plain: [true, true],
        swap_address: '0x056C6C5e684CeC248635eD86033378Cc444459B0',
        token_address: '0x0CA1C1eC4EBf3CC67a9f545fF90a3795b318cA4a',
        gauge_address: '0x78CF256256C8089d68Cde634Cf7cDEFb39286470', // NO GAUGE FOR THIS POOL BUT NECESSARY TO AVOID REVERTS
        underlying_coins: [
            '0xcB444e90D8198415266c6a2724b7900fb12FC56E',
            '0x1337BedC9D22ecbe766dF105c9623922A27963EC',
        ],
        coins: [
            '0xcB444e90D8198415266c6a2724b7900fb12FC56E',
            '0x1337BedC9D22ecbe766dF105c9623922A27963EC',
        ],
        deposit_abi: eureDepositABI,
        deposit_address: '0xE3FFF29d4DC930EBb787FeCd49Ee5963DADf60b6',
        is_meta: true,
        base_pool: '3pool',
        meta_N: 5,
        meta_precisions: [1e18, 1e18, 1e18, 1e6, 1e6],
        meta_coin_precisions: [1e18, 1e18, 1e6, 1e6],
        meta_wrapped_precisions: [1e18, 1e18],
        meta_coins: [
            '0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d',
            '0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83',
            '0x4ECaBa5870353805a9F068101A40E0f32ed605C6',
        ],
        all_coins: [
            '0xcB444e90D8198415266c6a2724b7900fb12FC56E',
            '0x1337BedC9D22ecbe766dF105c9623922A27963EC',
            '0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d',
            '0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83',
            '0x4ECaBa5870353805a9F068101A40E0f32ed605C6',
        ],
        is_factory: false,
    },
};


const factoryPoolDataSkeleton = {
    swap_abi: tripoolSwapABI,
    N_COINS: 3, // to fill and replace w/ null in skeleton
    coin_precisions: [1e18, 1e18], // to fill and replace w/ null in skeleton
    wrapped_precisions: [1e18, 1e18], // to fill and replace w/ null in skeleton
    tethered: [false, false], // to fill and replace w/ null in skeleton
    use_lending: [false, false], // to fill and replace w/ null in skeleton
    is_plain: [true, true], // to fill and replace w/ null in skeleton
    swap_address: '0xEd279fDD11cA84bEef15AF5D39BB4d4bEE23F0cA', // to fill and replace w/ null in skeleton
    token_address: '0xEd279fDD11cA84bEef15AF5D39BB4d4bEE23F0cA', // to fill and replace w/ null in skeleton
    gauge_address: '0x78CF256256C8089d68Cde634Cf7cDEFb39286470', // Fake gauge address to prevent old multicalls from reverting
    underlying_coins: [ // to fill and replace w/ null in skeleton
        '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
        '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
    ],
    coins: [ // to fill and replace w/ null in skeleton
        '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
        '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
    ],
    deposit_abi: lusdDepositABI,
    deposit_address: undefined,
    is_meta: true,
    base_pool: '3pool', // to fill and replace w/ null in skeleton
    meta_N: 5, // to fill and replace w/ null in skeleton
    meta_precisions: [1e18, 1e18, 1e18, 1e6, 1e6], // to fill and replace w/ null in skeleton
    meta_coin_precisions: [1e18, 1e18, 1e6, 1e6], // to fill and replace w/ null in skeleton
    meta_wrapped_precisions: [1e18, 1e18], // to fill and replace w/ null in skeleton
    meta_coins: [ // to fill and replace w/ null in skeleton
        '0x6B175474E89094C44Da98b954EedeAC495271d0F',
        '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    all_coins: [ // to fill and replace w/ null in skeleton
        '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
        '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
        '0x6B175474E89094C44Da98b954EedeAC495271d0F',
        '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    is_factory: true,
    sCurveRewards_abi: undefined,
    sCurveRewards_address: undefined,
    reward_token: undefined,
};



export {
    multicall_address,
    poolsData,
    factoryPoolDataSkeleton,
    Plain2Basic,
    Plain2BasicEMA,
    Plain2Balances,
    Plain2ETH,
    Plain2ETHEMA,
    Plain2Optimized,
    Plain3Basic,
    Plain3Balances,
    Plain3ETH,
    Plain3Optimized,
    Plain4Basic,
    Plain4Balances,
    Plain4ETH,
    Plain4Optimized,
    MetaUSD,
    MetaUSDBalances,
    MetaBTC,
    MetaBTCBalances,
};
